import React from 'react';
import FormControl from "@mui/material/FormControl";
import {Slider as BaseSlider} from "@mui/material";
import {Trans, useTranslation} from "react-i18next";
import Typography from "@mui/material/Typography";
import {styled} from "@mui/system";

const Slider = styled(BaseSlider)(
    ({theme}) => `
  & .valueLabel {
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: 600;
    font-size: 12px;
    position: relative;
    top: -2em;
    text-align: center;
    align-self: center;
  }
`,
);

function SliderValueLabel({children}) {
    return <span className="valueLabel">{children}</span>;
}

function SizeParam({id, values, onChange, value, forCart, props}) {
    const {ratio, defaultValue, maxValue} = props;
    const {t} = useTranslation();
    const {width} = value || {width: defaultValue || 20};

    const handleChange = (event, newWidth) => {
        const priceModifier = true;
        onChange(id, {width: newWidth, priceModifier});
    }

    const getLength = () => {
        const length = (ratio * width).toFixed(1);
        return `x ${length} cm `;
    }

    return (forCart ?
            <Typography sx={{color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', textWrap: 'nowrap'}}
                        variant={'body2'}>
                <Trans i18nKey={`params.${id}`}/>: {width.toFixed(1)} cm {ratio ? getLength() : ''} (W x L)
            </Typography> :
            <FormControl fullWidth>
                <Typography id={`${id}-label`}>
                    <Trans i18nKey={`params.${id}`}/>:
                    <br/>{width.toFixed(1)} cm {ratio ? getLength() : ''} {ratio ? '(W x L)' : t('params.width')}</Typography>
                <Slider
                    aria-label="slider"
                    value={width}
                    shiftStep={5}
                    step={1}
                    min={5}
                    max={maxValue || 28}
                    slots={{valueLabel: SliderValueLabel}}
                    onChange={handleChange}
                    color={'secondary'}
                />
            </FormControl>
    );
}

export default SizeParam;
